import Head from 'next/head';
import React, {useEffect} from "react";
import orderStyles from "styles/order.module.css";
import WindowCleaningHomeCard from "@crm/components/window-cleaning/window-cleaning-home-card";
import WindowCleaningWindowsCard from "@crm/components/window-cleaning/window-cleaning-windows-card";
import WindowCleaningTimeCard from "@crm/components/window-cleaning/window-cleaning-time-card";
import WindowCleaningUserCard from "@crm/components/window-cleaning/window-cleaning-user-card";
import WindowCleaningOrderHandlerCard from "@crm/components/window-cleaning/window-cleaning-order-handler-card";
import WindowCleaningPaymentCard from "@crm/components/window-cleaning/window-cleaning-payment-card";
import {windowCleaningActions, WindowCleaningPage} from "@crm/services/window-cleaning-slice";
import {useAppDispatch, useAppSelector} from "@crm/services/store";
import {selectWindowCleaningAuthenticated, selectWindowCleaningPage} from "@crm/services/window-cleaning-selectors";
import WindowCleaningPrice from "@crm/components/window-cleaning/window-cleaning-price";
import {authSelectors} from "@crm/services/auth-slice";

const Bestil = () => {
    const dispatch = useAppDispatch();

    const currentPage = useAppSelector(selectWindowCleaningPage);
    const windowCleaningAuthentication = useAppSelector(selectWindowCleaningAuthenticated);
    const isAuthenticated = useAppSelector(authSelectors.selectAuthenticated);
    const completed = useAppSelector(state => state.windowCleaning.completed);

    const shownPage = completed ? WindowCleaningPage.SUBMITTING_ORDER : currentPage;

    useEffect(() => {
        if (isAuthenticated != windowCleaningAuthentication) {
            dispatch(windowCleaningActions.setAuthenticated(isAuthenticated));
        }
    }, [dispatch, isAuthenticated, windowCleaningAuthentication]);

    const setPage = (page: WindowCleaningPage) => {
        if (!completed) {
            dispatch(windowCleaningActions.setPage(page))
        }
    }

    return <>
        <Head>
            <title>Vinduespudsning - Housekeepr</title>
            <meta name="description" content="Housekeepr - Bestil service og beregn pris" className=""/>
            <meta name="robots" content="noindex"/>
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"/>
            <link rel="icon" href="/favicon.ico"/>
            <script
                id="CookieConsent"
                src="https://policy.app.cookieinformation.com/uc.js"
                data-gcm-version="2.0"
                data-culture="DA"
                type="text/javascript"
                defer
            />
        </Head>


        <div className={orderStyles.container}>
            {completed
                ? <WindowCleaningOrderHandlerCard
                    key={WindowCleaningPage.SUBMITTING_ORDER}
                />
                : <>
                    <div className={orderStyles.progressContainer}>
                        <div className={orderStyles.progressSteps}>
                            <div
                                className={shownPage === WindowCleaningPage.HOME ? orderStyles.active : undefined}
                                onClick={() => setPage(WindowCleaningPage.HOME)}
                            >
                                Hjem
                            </div>
                            <div
                                className={shownPage === WindowCleaningPage.WINDOWS ? orderStyles.active : undefined}
                                onClick={() => setPage(WindowCleaningPage.WINDOWS)}
                            >
                                Vinduer
                            </div>
                            <div
                                className={shownPage === WindowCleaningPage.TIME ? orderStyles.active : undefined}
                                onClick={() => setPage(WindowCleaningPage.TIME)}
                            >
                                <div className={orderStyles.desktopText}>
                                    Tidspunkt
                                </div>
                                <div className={orderStyles.mobileText}>
                                    Tid
                                </div>
                            </div>
                            <div
                                className={shownPage === WindowCleaningPage.USER ? orderStyles.active : undefined}
                                onClick={() => setPage(WindowCleaningPage.USER)}
                            >
                                Bruger
                            </div>
                            <div
                                className={shownPage === WindowCleaningPage.PAYMENT ? orderStyles.active : undefined}
                                onClick={() => setPage(WindowCleaningPage.PAYMENT)}
                            >
                                <div className={orderStyles.desktopText}>
                                    Bestilling
                                </div>
                                <div className={orderStyles.mobileText}>
                                    Bestil
                                </div>
                            </div>
                        </div>
                        <div className={orderStyles.rail}>
                            <div
                                className={orderStyles.progress}
                                style={{width: `min(100%, calc(${(shownPage + 0.5) / 5} * 100% + 4px))`}}
                            />
                        </div>
                    </div>
                    <WindowCleaningHomeCard
                        hidden={shownPage !== WindowCleaningPage.HOME}
                        key={WindowCleaningPage.HOME}
                    />
                    <WindowCleaningWindowsCard
                        hidden={shownPage !== WindowCleaningPage.WINDOWS}
                        key={WindowCleaningPage.WINDOWS}
                    />
                    <WindowCleaningTimeCard
                        hidden={shownPage !== WindowCleaningPage.TIME}
                        key={WindowCleaningPage.TIME}
                    />
                    <WindowCleaningUserCard
                        hidden={shownPage !== WindowCleaningPage.USER}
                        key={WindowCleaningPage.USER}
                    />
                    <WindowCleaningPaymentCard
                        hidden={shownPage !== WindowCleaningPage.PAYMENT}
                        key={WindowCleaningPage.PAYMENT}
                    />
                    {shownPage == WindowCleaningPage.SUBMITTING_ORDER &&
                        <WindowCleaningOrderHandlerCard
                            key={WindowCleaningPage.SUBMITTING_ORDER}
                        />
                    }
                </>
            }
        </div>
        <WindowCleaningPrice/>
    </>;
};

export default Bestil;
